import styled from 'styled-components';

import { AddIconContainerStyled } from '../PlayerCard/AddIconContainer.Styles';
import { px } from '../../contrib/ui';

const borderHeight = 35;
const borderWidth = 15;

export const AddIconButton = styled(AddIconContainerStyled)`
  height: ${px(70)};
  top: 0;
  right: 0;

  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  &:before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    left: ${px(-1 * borderWidth)};
    position: absolute;

    border-width: ${px(borderHeight)} ${px(borderWidth)} ${px(borderHeight)} 0;
    border-color: transparent var(--mainColor) transparent transparent;
    background-color: transparent;
  }
`;
